import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
    selector: 'agreement-change-status-confirmation',
    templateUrl: './agreement-change-status-confirmation.component.html',
    styleUrls: ['./agreement-change-status-confirmation.component.scss']
})
export class AgreementChangeStatusConfirmationComponent {

    @Input() title: string;
    @Input() cancelButtonText: string = 'Назад';
    @Input() confirmButtonText: string = 'Подтвердить';

    @Output() onCancelEvent: EventEmitter<void> = new EventEmitter<void>();
    @Output() onConfirmEvent: EventEmitter<string> = new EventEmitter<string>();

    comment: string = null;

    cancel() {
        this.onCancelEvent.emit();
    }

    confirm() {
        this.onConfirmEvent.emit(this.comment);
    }

    get canConfirm(): boolean {
        return this.comment != null && this.comment.trim() != '';
    }
}
